<script lang="ts">
    import { faEllipsisH } from '@fortawesome/free-solid-svg-icons'
    import { onMount, tick } from 'svelte'
    import Fa from 'svelte-fa'
    import type { ZdropInterface } from './zdrop.interface'

    let className = ''
    export { className as class }
    export let menu: ZdropInterface

    let popup
    let showMenu = false
    async function goToggleMenu(ev) {
        showMenu = !showMenu
        if (!showMenu) return
        await tick()

        popup.style.top = 0
        popup.style.left = 0
        let top = ev.clientY + 55
        let left = ev.clientX + 35
        if (left + popup.clientWidth > window.innerWidth - 8) {
            left = window.innerWidth - popup.clientWidth - 16
        }
        if (top + popup.clientHeight > window.innerHeight - 8) {
            top = top - popup.clientHeight - 64
        }
        if (left - 16 < 0) left = 24
        popup.style.top = top - 24 + 'px'
        popup.style.left = left - 16 + 'px'
    }

    let style = ''
    function setDropStyle() {
        style = ''
        if (!menu.positionMargin) menu.positionMargin = '0px;'
        if (menu.position !== 'flow') {
            style = 'position:absolute;'
            if (menu.position === 'top-right') {
                style += 'top:' + menu.positionMargin + ';right:' + menu.positionMargin + ';'
            }
            if (menu.position === 'top-left') {
                style += 'top:' + menu.positionMargin + ';left:' + menu.positionMargin + ';'
            }
        }
    }

    let lastScroll = 0
    function evaluateScroll(el) {
        let scrollTop = el.scrollTop
        let change = scrollTop - lastScroll
        if (change < 0) change = -change
        if (change > 7) {
            showMenu = false
        }
        lastScroll = scrollTop
    }

    onMount(() => {
        setDropStyle()
        document.addEventListener(
            'scroll',
            (event) => {
                evaluateScroll(event.target)
            },
            true,
        )
    })
</script>

<div class="zdrop {className} zdrop_format-{menu.format}" {style} on:click|stopPropagation={goToggleMenu}>
    <div class="zdrop_icon_outer">
        <slot></slot>
        {#if !$$slots.default}
            <div class="zdrop_icon zbutton">
                <Fa icon={menu.icon || faEllipsisH}></Fa>
            </div>
        {/if}
    </div>
    {#if showMenu}
        <div class="zdrop_menu_outer" on:click|stopPropagation={goToggleMenu}></div>
        <div bind:this={popup} class="zdrop_menu">
            {#each menu.buttons as item}
                <button
                    on:click|stopPropagation={() => {
                        if (item.disabled) return
                        showMenu = false
                        item.callback(item.data || undefined)
                    }}
                    class="zdrop_menu_item zdrop_item_disabled-{item.disabled}"
                    title={item.help || null}
                >
                    {#if item.icon}
                        <!-- a vaga tem largura fixa e o ícone encosta na esquerda dela: os ícones do
                             FontAwesome têm larguras bem diferentes e, centralizados, a coluna fica torta -->
                        <span class="zdrop_menu_icone"><Fa icon={item.icon}></Fa></span>
                    {/if}
                    {#if item.label}
                        <span>{item.label}</span>
                    {/if}
                </button>
            {/each}
        </div>
    {/if}
</div>

<style>
    .zdrop {
        position: relative;
        overflow: visible;
        user-select: none;
    }

    .zdrop_icon {
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 13px;
        cursor: pointer;
        height: 44px;
        min-width: 44px;
    }

    .zdrop_format-circle .zdrop_icon {
        border-radius: 50%;
    }

    .zdrop_icon:hover {
        background-color: #99999999;
    }

    /* Mesma estética do menu de tipo do compositor de notas (notes-composer): painel com respiro
       em volta dos itens, cada item com seu próprio arredondado e o destaque no hover, em vez de
       linhas divisórias. Os valores são os mesmos de lá, de propósito — se um mudar, mude os dois. */
    .zdrop_menu {
        position: fixed;
        z-index: 5;
        display: flex;
        flex-direction: column;
        min-width: 140px;
        padding: 4px;
        border-radius: 10px;
        background-color: #262626;
        border: 1px solid #ffffff1a;
        box-shadow: 0px 8px 24px #00000080;
        /* só opacidade e transform: nada aqui altera clientWidth/clientHeight, que o goToggleMenu
           mede logo depois de abrir para decidir se o menu cabe abaixo do clique */
        animation: zdrop_menu_in 0.12s ease-out;
    }

    @keyframes zdrop_menu_in {
        from {
            opacity: 0;
            transform: translateY(-4px) scale(0.98);
        }
        to {
            opacity: 1;
            transform: none;
        }
    }

    .zdrop_menu .zdrop_menu_item {
        display: flex;
        align-items: center;
        gap: 10px;
        width: 100%;
        text-align: left;
        text-decoration: none;
        cursor: pointer;
        font-size: 14px;
        background: none;
        color: #eee;
        border: 0px;
        border-radius: 7px;
        padding: 9px 10px;
    }

    .zdrop_menu .zdrop_menu_item:hover {
        background-color: #ffffff12;
    }

    /* largura fixa para os rótulos alinharem entre si, com ou sem ícone */
    /* vaga de largura fixa; o ícone ocupa o que precisa dentro dela, encostado na esquerda */
    .zdrop_menu .zdrop_menu_icone {
        flex: 0 0 18px;
        display: flex;
        align-items: center;
        justify-content: flex-start;
    }
    .zdrop_menu .zdrop_menu_item :global(svg) {
        /* sem largura fixa: assim o desenho preenche a própria caixa e todos começam no mesmo ponto.
           A altura vem do font-size (o svelte-fa aplica height: 1em no style do elemento). */
        max-width: 18px;
        font-size: 16px;
    }

    .zdrop_menu .zdrop_item_disabled-true {
        opacity: 0.3;
        pointer-events: none;
    }

    :global(.theme_light) .zdrop_menu {
        background-color: #fff;
        border-color: #e8eaed;
        box-shadow: 0px 8px 24px #0000002e;
    }

    :global(.theme_light) .zdrop_menu .zdrop_menu_item {
        color: #202124;
    }

    :global(.theme_light) .zdrop_menu .zdrop_menu_item:hover {
        background-color: #0000000a;
    }

    /* A camada que fecha no clique de fora fica invisível: o menu de referência não escurece nada
       atrás. Ela continua existindo (em vez de um listener de clique no documento) porque assim o
       clique que fecha não aciona junto o que estava embaixo dele. */
    .zdrop_menu_outer {
        background-color: transparent;
        position: fixed;
        top: 0px;
        left: 0px;
        width: 100%;
        height: 100%;
        z-index: 2;
    }

    @media (max-width: 900px) {
        .zdrop_menu .zdrop_menu_item {
            padding-top: 12px;
            padding-bottom: 12px;
        }
    }
</style>
